import { render, staticRenderFns } from "./ShouHuoKanban.vue?vue&type=template&id=1430eb04"
import script from "./ShouHuoKanban.vue?vue&type=script&lang=js"
export * from "./ShouHuoKanban.vue?vue&type=script&lang=js"
import style0 from "./ShouHuoKanban.vue?vue&type=style&index=0&id=1430eb04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports